module.exports = __webpack_public_path__ + "static/media/payrollLocation.c0cfaf49.svg";